var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#2C2929"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_227_7779",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 56,
    height: 56
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_227_7779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9997 69C44.7719 69 42.0205 67.8625 39.7455 65.5875C37.4705 63.3125 36.333 60.5611 36.333 57.3333C36.333 55.4667 36.7413 53.7264 37.558 52.1125C38.3747 50.4986 39.5219 49.1278 40.9997 48V34C40.9997 32.0556 41.6802 30.4028 43.0413 29.0417C44.4025 27.6806 46.0552 27 47.9997 27C49.9441 27 51.5969 27.6806 52.958 29.0417C54.3191 30.4028 54.9997 32.0556 54.9997 34V48C56.4775 49.1278 57.6247 50.4986 58.4413 52.1125C59.258 53.7264 59.6663 55.4667 59.6663 57.3333C59.6663 60.5611 58.5288 63.3125 56.2538 65.5875C53.9788 67.8625 51.2275 69 47.9997 69ZM47.9997 64.3333C49.9441 64.3333 51.5969 63.6528 52.958 62.2917C54.3191 60.9306 54.9997 59.2778 54.9997 57.3333C54.9997 56.2056 54.7566 55.1556 54.2705 54.1833C53.7844 53.2111 53.0941 52.3944 52.1997 51.7333L50.333 50.3333V34C50.333 33.3389 50.1094 32.7847 49.6622 32.3375C49.215 31.8903 48.6608 31.6667 47.9997 31.6667C47.3386 31.6667 46.7844 31.8903 46.3372 32.3375C45.89 32.7847 45.6663 33.3389 45.6663 34V50.3333L43.7997 51.7333C42.9052 52.3944 42.215 53.2111 41.7288 54.1833C41.2427 55.1556 40.9997 56.2056 40.9997 57.3333C40.9997 59.2778 41.6802 60.9306 43.0413 62.2917C44.4025 63.6528 46.0552 64.3333 47.9997 64.3333Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.123b6a9c678b0c4d468dbcd48d25a1e5.svg";
export { ForwardRef as ReactComponent };